import PathConstants from '@/main/routes/paths'
import { SvgIconComponent } from '@mui/icons-material'
import { SxProps, Theme } from '@mui/material'

export type MenuVariant = 'desktop' | 'mobile'

export interface MenuItemUnifiedProps {
  variant: MenuVariant
  route: PathConstants.RouteProps
  availableIn?: PathConstants.RouteProps[]
  icon?: SvgIconComponent
  className?: string
  onClick?: () => void
  onClose: () => void
  sx?: SxProps<Theme>
}

export interface MenuItemDefinition {
  key: string
  route: PathConstants.RouteProps
  icon: SvgIconComponent
  availableIn?: PathConstants.RouteProps[]
  isVisible?: boolean
  onClick?: () => void
  className?: string // For 'only-mobile' or 'only-desktop' visibility
}

export interface CollapsibleMenuDefinition {
  key: string
  icon: SvgIconComponent
  titleKey: string
  items: MenuItemDefinition[]
  isVisible?: boolean
}

export interface MenuSectionDefinition {
  titleKey?: string
  items: (MenuItemDefinition | CollapsibleMenuDefinition)[]
}

export function isCollapsibleMenu(
  item: MenuItemDefinition | CollapsibleMenuDefinition
): item is CollapsibleMenuDefinition {
  return 'items' in item && Array.isArray(item.items)
}
